import React, { useEffect, useState } from "react";
import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Colors } from "../../../assets/Colors";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { fetchGet, fetchPost } from "../../../fetchers";
import LOGO_RKS from "../../../assets/logo/LOGO_RKS.png";
import angkaTerbilang from "@develoka/angka-terbilang-js"; // if using import
const PAGE_HEIGHT = 882; // Change this to your desired page height
const MARGIN = 15; // Adjust as needed

const ROWS_PER_PAGE = Math.floor((PAGE_HEIGHT - 2 * MARGIN) / 20); // Assuming each row is 20 units in height

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
  },
  viewHeader: {
    width: 250,
    marginLeft: 120,
  },
  title_sub: {
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
  },
  header_kepada: {
    fontWeight: "bold",
    fontSize: 12,
  },
  bottom_ttd: {
    marginTop: 40,
    fontWeight: "bold",
    fontSize: 9,
    width: 100,
  },
  bottom_ttd_name: {
    fontWeight: "bold",
    fontSize: 9,
    width: 60,
  },
  header_namasupp: {
    fontWeight: "bold",
    fontSize: 12,
    textTransform: "capitalize",
  },
  title_border: {
    borderBottom: 1,
    fontSize: 12,
    textAlign: "center",
  },
  Stitle_border: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 20,
  },

  header_section: {
    flexDirection: "row",
  },

  header_title: {
    width: 150,
    fontSize: 9,
    textAlign: "justify",
  },
  header_Right: {
    width: 70,
    marginLeft: 105,
    fontSize: 9,
    textAlign: "left",
  },

  header_Left: {
    width: 70,
    marginLeft: 0,
    fontSize: 9,
    textAlign: "left",
  },
  header_Rightv: {
    width: 70,
    marginLeft: 133,
    fontSize: 9,
    textAlign: "left",
  },
  header_mark: {
    width: 15,
    fontSize: 9,
    textAlign: "justify",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 9,
    textAlign: "justify",
  },
  text2: {
    width: 120,
    fontSize: 9,
    textAlign: "justify",
  },

  table: {
    borderLeftWidth: 1,
    // borderRadius: 5,
    borderStyle: "solid",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellSecondary: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderTop: 0,
    borderLeftWidth: 0,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellClosing: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  paddings: {
    paddingTop: 10,
  },
  logo: {
    width: 200,
    marginBottom: 20,
    marginLeft: 325,
  },

  logottd: {
    height: 50,
    fontWeight: "bold",
    fontSize: 9,
    width: 90,
  },
});

const combineStyles = (main, override) => {
  let result = { ...main };
  let ov = { ...override };
  if (typeof override === "object") {
    Object.assign(result, ov);
  }
  return result;
};
// Create Document Component
const BlankoPOReturn = (props) => {
  const data = props.data;
  const Headermaker = (props) => (
    <View style={styles.header_section}>
      <Text style={styles.header_title}>{props.nama}</Text>
      <Text style={styles.header_mark}>:</Text>
      <Text style={styles.text}>{props.data}</Text>
    </View>
  );
  const HeaderTableMaker = (props) => {
    let style = { width: props.width + "%", maxWidth: props.width + "%" };
    let style2 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 22 };
    }
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };
  const HeaderTableMakerV2 = (props) => {
    let style = { width: props.width + "%" };
    let style2 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 22 };
    }
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };
  const SecondaryTableMaker = (props) => {
    let style = { width: props.width + "%" };
    let style2 = {};
    if (props.closing) {
      style2 = { borderBottom: 1 };
    }
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 22 };
    }

    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cellSecondary, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };

  const splitStringByWidth = (inputString, maxWidth) => {
    const MAX_WIDTH = maxWidth;
    const words = inputString.split(" ");
    let currentLine = words[0];
    let result = "";

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const tempLine = `${currentLine} ${word}`;

      if (tempLine.length > MAX_WIDTH) {
        result += currentLine + "\n";
        currentLine = word;
      } else {
        currentLine = tempLine;
      }
    }

    result += currentLine;
    return result;
  };

  const splitStringByWidthv1 = (inputString, maxWidth) => {
    const MAX_WIDTH = maxWidth;
    const words = inputString.split(" ");
    let currentLine = words[0];
    let result = [];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const tempLine = `${currentLine} ${word}`;

      if (tempLine.length > MAX_WIDTH) {
        result.push(currentLine);
        currentLine = word;
      } else {
        currentLine = tempLine;
      }
    }

    result.push(currentLine);
    return result;
  };

  let Total = 0;
  data.Data &&
    data.Data.map((values, id) => {
      Total += parseFloat(values.HargaSatuan) * parseFloat(values.Quantity);
    });
  const Discount = parseFloat(
    Total - (Total - (Total * data.DiscPercent) / 100 - data.DiscRupiah)
  );
  const TotalDisc = parseFloat(Total - Discount);
  const PPN = parseFloat((TotalDisc * data.PPN) / 100);
  const PPH = parseFloat((TotalDisc * data.PPH) / 100);
  const PBBKB = parseFloat((TotalDisc * data.PBBKB) / 100);
  // Biaya Lain-lain PC (di luar biaya utama, setelah pajak); 0 bila tak ada.
  const GTotal = parseFloat(TotalDisc + PPN + PPH + PBBKB + (parseFloat(data.BiayaLain) || 0));
  const stringArray = splitStringByWidthv1(
    angkaTerbilang(GTotal.toFixed(0)) + " rupiah",
    70
  );
  const filteredData = props.ttd.filter(
    (obj) => obj.Group === "MSR" && obj.NamaBagian === data.BagianID
  )[[0]];

  let firstString;
  let secondString = "";

  if (stringArray.length === 0) {
    firstString = angkaTerbilang(GTotal) + " rupiah";
  } else {
    firstString = stringArray[0];
    secondString = stringArray[1] + " rupiah";
  }
  const sections = [];

  // Split data into sections that fit on a single page
  for (let i = 0; i < data.PRList.length; i += ROWS_PER_PAGE) {
    sections.push(data.PRList.slice(i, i + ROWS_PER_PAGE));
  }
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <Image style={styles.logo} src={LOGO_RKS} />
        <View style={styles.viewHeader}>
          <Text style={styles.title_border}>MATERIAL AND SERVICE REQUEST</Text>
        </View>
        <View>
          <Text style={styles.Stitle_border}>{data.PurchaseOrderID}</Text>
        </View>

        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Office/Location"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text2}>{data.BisnisUnitID}</Text>
          <Text style={styles.header_Right}>{"MSR No."}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.PurchaseRequisitionID}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Request Date"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text2}>
            {new Date(data.DatePR).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}
          </Text>
          <Text style={styles.header_Right}>{"MSR Type"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.Tipe}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Request By"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text2}>{data.Requester}</Text>
          <Text style={styles.header_Right}>{"Expected Date"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.Sifat}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Departement"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text2}>{data.BagianID}</Text>
          <Text style={styles.header_Right}>{"Due Date"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>
            {new Date(data.DatePR).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_Left}>{"Remarks"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text2}>{data.Remarks}</Text>
        </View>

        <View style={styles.paddings}></View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <HeaderTableMaker colored={true} width={5} title={"No"} />
            <HeaderTableMaker colored={true} width={35} title={"Description"} />
            <HeaderTableMaker colored={true} width={10} title={"Qty"} />
            <HeaderTableMaker colored={true} width={10} title={"Unit"} />
            <HeaderTableMaker colored={true} width={25} title={"Specification"} />
            <HeaderTableMaker colored={true} width={15} title={"Keterangan"} />
          </View>
        </View>
        {sections.map((section, sectionIndex) => {
          let num = 0;
          if (sectionIndex > 0) {
            num = 42 * sectionIndex;
          }
          return (
            <View style={styles.table}>
              {section &&
                section.map((values, id) => {
                  let closing = false;
                  if (id === section.length - 1) {
                    closing = true;
                  }
                  const newBody = splitStringByWidth(
                    values.BarangID + " - " + values.NamaBarang,
                    30
                  );
                  const Specification = splitStringByWidth(
                    values.Specification,
                    20
                  );

                  return (
                    <View style={styles.tableRow}>
                      <HeaderTableMaker
                        closing={closing}
                        width={5}
                        title={id + 1 + num}
                      />
                      <HeaderTableMaker
                        closing={closing}
                        width={35}
                        title={newBody}
                      />
                      <HeaderTableMaker
                        number={true}
                        closing={closing}
                        width={10}
                        title={parseFloat(values.Qty).toLocaleString("in-ID", {
                          maximumFractionDigits: 0,
                        })}
                      />
                      <HeaderTableMaker
                        closing={closing}
                        width={10}
                        title={values.NamaSatuan}
                      />
                      <HeaderTableMaker
                        closing={closing}
                        width={25}
                        title={Specification}
                      />
                      <HeaderTableMaker
                        closing={closing}
                        width={15}
                        title={values.Keterangan}
                      />
                    </View>
                  );
                })}
              <View> </View>
            </View>
          );
        })}

        {data.Tipe == "Jasa" ? (
          <>
            <Text style={styles.bottom_ttd}>{"Termin:"}</Text>

            <View style={styles.table}>
              <View style={styles.tableRow}>
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`1`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${data.Termin1}%`}
                />
              </View>
              <View style={styles.tableRow}>
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`2`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${data.Termin2}%`}
                />
              </View>
              <View style={styles.tableRow}>
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`3`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${data.Termin3}%`}
                />
              </View>

              <View> </View>
            </View>
          </>
        ) : null}

        <View style={styles.header_section}>
          <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Prepared By"}</Text>
            <Image
              style={styles.logottd}
              src={
                "/speciment/" + data.NamaKaryawan.replaceAll(" ", "") + ".png"
              }
            />
            {/* <Text style={styles.bottom_ttd}>{"__________________ "}</Text> */}
            <Text style={styles.bottom_ttd_name}>{data.NamaKaryawan}</Text>
          </View>
          <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Head Departement"}</Text>
            <Image
              style={styles.logottd}
              src={
                "/speciment/" +
                data.HeadDeptApproval.replaceAll(" ", "") +
                ".png"
              }
            />
            <Text style={styles.bottom_ttd_name}>{data.HeadDeptApproval}</Text>
          </View>
          {/* <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Review"}</Text>
            <Image
              style={styles.logottd}
              src={"/speciment/" + data.Requester.replaceAll(" ", "") + ".png"}
            />
            <Text style={styles.bottom_ttd_name}>{data.Requester}</Text>
          </View> */}
          <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Review"}</Text>
            <Image
              style={styles.logottd}
              src={
                filteredData.Detail != null
                  ? "/speciment/" + "Rifi Harianto".replaceAll(" ", "") + ".png"
                  : ""
              }
            />
            <Text style={styles.bottom_ttd_name}>{"Rifi Harianto"}</Text>
          </View>

          <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Base Manager"}</Text>
            <Image
              style={styles.logottd}
              src={
                filteredData.Detail != null
                  ? "/speciment/" + "Aris Sugiyanto".replaceAll(" ", "") + ".png"
                  : ""
              }
            />
            <Text style={styles.bottom_ttd_name}>Aris Sugiyanto</Text>
          </View>
          <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Director Operational"}</Text>
            <Image
              style={styles.logottd}
              src={"/speciment/" + "Aldi Harris".replaceAll(" ", "") + ".png"}
            />
            <Text style={styles.bottom_ttd_name}>{"Aldi Harris"}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

const BlankoPR = () => {
  const params = useParams();
  const mutationGetBlanko = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisitionBlanko/" + formData)
  );
  const approval = useMutation((formData) =>
    fetchPost("Master/Approval/getAll")
  );

  useEffect(() => {
    if (params.id) {
      mutationGetBlanko.mutate(params.id.replaceAll("-", "/"));
      approval.mutate();
    }
  }, []);

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-screen -mt-32">
        {mutationGetBlanko.data && approval.data && (
          <PDFViewer className={"h-screen w-full"}>
            {
              <BlankoPOReturn
                data={mutationGetBlanko.data.data}
                ttd={approval.data.data}
              />
            }
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default BlankoPR;
